import React, { Fragment } from "react";

import { makeStyles } from "@material-ui/styles";

const useStyle = makeStyles({
  root: {
    position: "fixed",
    zIndex: 0,
    width: "100vw",
    height: "100vh",
  },
  rootForm: {
    display: "flex",

    position: "absolute",
    zIndex: 1,
  },
});

const UserLayout = ({ children }) => {
  const classes = useStyle();

  return (
    <Fragment>
      <main>
        <div className={classes.rootForm}>{children}</div>
      </main>
      <div className={classes.root} style={{}}></div>
    </Fragment>
  );
};

export default UserLayout;
